import {
  ApiError,
  createProductApiClient,
  type ApiEnvelope,
} from "@ilabel/platform-core";
import { vlaProductConfig } from "@ilabel/product-config";

export { ApiError };
export type { ApiEnvelope };

export const AUTH_EVENT_STORAGE_KEY = "ilabel_auth_event";
export interface AuthEvent {
  readonly accountId: string;
  readonly kind: "login" | "session-replaced" | "browser-account-switched";
  readonly at: number;
}

export function publishAuthEvent(event: Omit<AuthEvent, "at">) {
  try {
    localStorage.setItem(
      AUTH_EVENT_STORAGE_KEY,
      JSON.stringify({ ...event, at: Date.now() } satisfies AuthEvent),
    );
  } catch {
    // Session polling remains the fallback when storage events are unavailable.
  }
}

export const api = createProductApiClient(vlaProductConfig);

export const resources = {
  projects: () => api<Array<Record<string, unknown>>>("/projects"),
  teams: () => api<Array<Record<string, unknown>>>("/teams"),
  members: () => api<Array<Record<string, unknown>>>("/members"),
  libraries: () => api<Array<Record<string, unknown>>>("/config-libraries"),
  data: () => api<Array<Record<string, unknown>>>("/annotation-data"),
  tasks: () => api<Array<Record<string, unknown>>>("/tasks"),
};
